import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const LargeAndSmall = ({ slot }) => {

	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={90}
				height={85}
				component={slot[0].type}
				data={slot[0].data}
				layout={slot[0].layout}
			/>
			<Slot
				top={70}
				left={65}
				width={25}
				height={25}
				component={slot[1].type}
				data={slot[1].data}
				layout={slot[1].layout}
			/>
		</Layout>
	)
}

LargeAndSmall.defaultProps = {
	slot: []
}

LargeAndSmall.propTypes = {
	slot: PropTypes.array,
}

export default LargeAndSmall
